import { ChangeEvent, useContext, useState } from "react";
import { Input } from "../../Input";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";
import Titulo from "../../Modal/ModaisConfigsPrimeiroAcesso/Titulo/Titulo";
import { Toggle } from "../../Toggle/Toggle";
import ModalRelativo from "../../ModalRelativo/ModalRelativo";
import { copy } from "../../../services/Functions";
import Hide from "../../Uteis/Hide";
import ContainerConfigCorreios from "./styles";
import Dropdown from "../../Dropdowns/Dropdown";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { cepMask } from "../../../services/Masks";
import { validateCep } from "../../../services/MasksValidations";
import { unmaskToNumbers } from "../../../services/Unmasks";
import PopoverInfo from "../../PopoverInfo/PopoverInfo";
import { AuthContext } from "../../../contexts/Auth/AuthContext";


interface ConfigCorreiosProps {
  configIn: "empresa" | "configuracoes";
}

export const ConfigCorreios: React.FC<ConfigCorreiosProps> = ({ configIn }) => {
  const { configuracoes, setConfiguracoes } = useContext(ConfiguracoesContext);
  const [modalConfigAvancadas, setModalConfigAvancadas] = useState(false);

  const { permissoesPlanos } = useContext(AuthContext);

  const [configuracoesAvancadasAuxiliar, setConfiguracoesAvancadasAuxiliar] =
    useState<{
      opcoes: [
        { ativo: boolean; tipo: string; descricao: string; codigo: string },
        { ativo: boolean; tipo: string; descricao: string; codigo: string },
        { ativo: boolean; tipo: string; descricao: string; codigo: string },
        { ativo: boolean; tipo: string; descricao: string; codigo: string },
      ];
      dimensoes: {
        comprimento: string;
        largura: string;
        altura: string;
        peso: string;
      };
    }>({
      opcoes: [...configuracoes.frete.opcoes],
      dimensoes: { ...configuracoes.frete.dimensoes },
    });

  const { theme } = useTheme();

  const isConfigsValid = () => {
    return (
      Number(configuracoes.frete.configuracoes.cep_origem) > 0 &&
      Number(configuracoes.frete.dimensoes.comprimento) > 0 &&
      Number(configuracoes.frete.dimensoes.altura) > 0 &&
      Number(configuracoes.frete.dimensoes.largura) > 0 &&
      Number(configuracoes.frete.dimensoes.peso) > 0 &&
      configuracoes.frete.opcoes.filter((opcao) => opcao.ativo).length > 0 &&
      validateCep(configuracoes.frete.configuracoes.cep_origem)
    );
  };

  const handleInputCepChange = (newValue: string, name?: string) => {
    setConfiguracoes({
      ...configuracoes,
      frete: {
        ...configuracoes.frete,
        configuracoes: {
          ...configuracoes.frete.configuracoes,
          [name!]: newValue,
        },
      },
    });
  };

  const handleToggleChange = (newValue: Boolean, index: number) => {
    const copia = copy(configuracoes);
    copia.frete.opcoes[index].ativo = newValue;
    setConfiguracoes(copia);
  };

  const handleInputChange = (newValue: string, name?: string) => {
    //check if value is a number
    if (isNaN(Number.parseInt(newValue))) return;

    if (Number.parseInt(newValue) <= 99999) {
      setConfiguracoes({
        ...configuracoes,
        frete: {
          ...configuracoes.frete,
          dimensoes: { ...configuracoes.frete.dimensoes, [name!]: newValue },
          configuracoes: {...configuracoes.frete.configuracoes, [name!]: newValue},
        },
      });
    }
  };

  return (
    <>
      <ContainerConfigCorreios configIn={configIn} theme={theme}>
        {configIn === "empresa" && (
            <Titulo
              justifyContent="center"
              flexDirection="column-reverse"
              titulo="Correios"
              subtitulo={``}
            />
          )}
        <div className="textoOpcoesCorreios fonteTexto">
          A integração com os Correios funciona para contratos a partir do plano <strong>Platinum.</strong> Contratos do Clube Correios não tem suporte a API. <br />
          Caso você tenha algum deles, preencha os dados do seu contrato com os Correios para configurar os
          fretes. 
        </div>
        <div className="contratoComCorreios">
          <div className="titulo fonteSubtitulo">Dados do contrato</div>
          <div className="opcoesAvancadasCorreios">
          <div className="opcao fonteTexto">
            <Toggle
              value={configuracoes.frete.configuracoes.seguro}
              onChange={(newValue) => {
                setConfiguracoes({
                  ...configuracoes,
                  frete: {
                    ...configuracoes.frete,
                    configuracoes: {
                      ...configuracoes.frete.configuracoes,
                      seguro: newValue,
                    },
                  },
                });
              }}
            />
            Seguro
          </div>
        </div>
          <div className="grid-inputs">
            <div className="containerInput">
              <Input
                maxLength={75}
                showMaxLength={false}
                name="numeroContrato"
                type="text"
                value={configuracoes.frete.configuracoes.codigo_administrativo}
                required={true}
                placeholder={""}
                label="Token"
                alignLabel="left"
                ignoreValidations={!configuracoes.frete.correiosAtivo}
                onChange={(newValue) => {
                  setConfiguracoes({
                    ...configuracoes,
                    frete: {
                      ...configuracoes.frete,
                      configuracoes: {
                        ...configuracoes.frete.configuracoes,
                        codigo_administrativo: newValue,
                      },
                    },
                  });
                }}
              />
            </div>
            <div className="containerInput">
              <Input
                maxLength={75}
                type="text"
                showMaxLength={false}
                name="numeroContrato"
                label="Contrato"
                alignLabel="left"
                value={configuracoes.frete.configuracoes.contrato}
                required={true}
                placeholder={""}
                ignoreValidations={!configuracoes.frete.correiosAtivo}
                onChange={(newValue) => {
                  setConfiguracoes({
                    ...configuracoes,
                    frete: {
                      ...configuracoes.frete,
                      configuracoes: {
                        ...configuracoes.frete.configuracoes,
                        contrato: newValue,
                      },
                    },
                  });
                }}
              />
            </div>
            <div className="containerInput">
              <Input
                maxLength={75}
                showMaxLength={false}
                required={true}
                name="numeroContrato"
                type="text"
                label="Usuário"
                alignLabel="left"
                value={configuracoes.frete.configuracoes.usuario}
                placeholder={""}
                ignoreValidations={!configuracoes.frete.correiosAtivo}
                onChange={(newValue) => {
                  setConfiguracoes({
                    ...configuracoes,
                    frete: {
                      ...configuracoes.frete,
                      configuracoes: {
                        ...configuracoes.frete.configuracoes,
                        usuario: newValue,
                      },
                    },
                  });
                }}
              />
            </div>
            <div className="containerInput">
              <Input
                maxLength={75}
                showMaxLength={false}
                name="numeroContrato"
                required={true}
                type="text"
                label="Cartão de postagem"
                alignLabel="left"
                value={configuracoes.frete.configuracoes.cartao}
                placeholder={""}
                ignoreValidations={!configuracoes.frete.correiosAtivo}
                onChange={(newValue) => {
                  setConfiguracoes({
                    ...configuracoes,
                    frete: {
                      ...configuracoes.frete,
                      configuracoes: {
                        ...configuracoes.frete.configuracoes,
                        cartao: newValue,
                      },
                    },
                  });
                }}
              />
            </div>
          </div>

          <div className="titulo fonteSubtitulo">Modalidades de entrega</div>
          <div className="opcoesDeFrete">
            {configuracoes.frete.opcoes.map((opcao, index) => {
              return (
                <div className="opcao-container">
                  <label className="opcao fonteTexto" key={index}>
                    <Toggle
                      value={opcao.ativo}
                      onChange={(newValue) => {
                        handleToggleChange(newValue, index);
                      }}
                    ></Toggle>
                    {opcao.descricao}
                  </label>
                  {opcao.ativo && (
                    <div className="containerInput">
                      <Input
                        maxLength={75}
                        showMaxLength={false}
                        required={true}
                        ignoreValidations={!configuracoes.frete.correiosAtivo}
                        type="text"
                        alignLabel="left"
                        value={opcao.codigo}
                        placeholder={`Código ${opcao.descricao}`}
                        onChange={(newValue) => {
                          const copia = copy(configuracoes);
                          copia.frete.opcoes[index].codigo = newValue;
                          setConfiguracoes(copia);
                        }}
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="titulo fonteSubtitulo">Configurações de envio</div>
          <div className="grid-inputs">
            <div className="containerInput">
              <Input
                maxLength={75}
                showMaxLength={false}
                name="cep_origem"
                type="text"
                label="CEP de origem"
                alignLabel="left"
                value={configuracoes.frete.configuracoes.cep_origem}
                placeholder={"99200-000"}
                onChange={handleInputCepChange}
                required={true}
                ignoreValidations={!configuracoes.frete.correiosAtivo}
                mask={{
                  mask: cepMask,
                  unmask: unmaskToNumbers,
                }}
              />
            </div>

            <div className="containerInput">
              <Input
                maxLength={75}
                showMaxLength={false}
                labelIcon={
                  <PopoverInfo
                    mensagem="Esse prazo é referente a separação dos produtos e será adicionado ao prazo estimado da logística escolhida."
                    width="78rem"
                    className="popoverCorreios"
                  />
                }
                type={"number"}
                label="Prazo de expedição"
                alignLabel="left"
                name="diasEntregaCorreios"
                value={configuracoes.frete.configuracoes.diasEntregaCorreios !== undefined &&
                  Number(configuracoes.frete.configuracoes.diasEntregaCorreios) > 0
                  ? configuracoes.frete.configuracoes.diasEntregaCorreios.toString()
                  : ""
                }
                placeholder={"Dias para separação do pedido"}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="titulo fonteSubtitulo">Embalagem</div>
          <div className="embalagemContainer">
            <div className="containerInput">
              <Input
                maxLength={75}
                showMaxLength={false}
                type={"number"}
                name="comprimento"
                label="Comprimento (cm)"
                alignLabel="left"
                value={Number.parseFloat(configuracoes.frete.dimensoes.comprimento) > 0
                  ? configuracoes.frete.dimensoes.comprimento.toString()
                  : ""
                }
                placeholder={"Comprimento (cm)"}
                onChange={handleInputChange}
                required={true}
                ignoreValidations={!configuracoes.frete.correiosAtivo}
              />
            </div>

            <div className="containerInput">
              <Input
                maxLength={75}
                showMaxLength={false}
                type={"number"}
                name="altura"
                label="Altura (cm)"
                alignLabel="left"
                value={Number.parseFloat(configuracoes.frete.dimensoes.altura) > 0
                  ? configuracoes.frete.dimensoes.altura.toString()
                  : ""
                }
                placeholder={"Altura (cm)"}
                onChange={handleInputChange}
                required={true}
                ignoreValidations={!configuracoes.frete.correiosAtivo}
              />
            </div>

            <div className="containerInput">
              <Input
                maxLength={75}
                showMaxLength={false}
                type={"number"}
                label="Largura (cm)"
                alignLabel="left"
                name="largura"
                value={Number.parseFloat(configuracoes.frete.dimensoes.largura) > 0
                  ? configuracoes.frete.dimensoes.largura.toString()
                  : ""
                }
                placeholder={"Largura (cm)"}
                onChange={handleInputChange}
                required={true}
                ignoreValidations={!configuracoes.frete.correiosAtivo}
              />
            </div>

            <div className="containerInput">
              <Input
                maxLength={75}
                showMaxLength={false}
                type={"number"}
                label="Peso (gr)"
                alignLabel="left"
                name="peso"
                value={Number.parseFloat(configuracoes.frete.dimensoes.peso) > 0
                  ? configuracoes.frete.dimensoes.peso.toString()
                  : ""
                }
                placeholder={"Peso (gr)"}
                onChange={handleInputChange}
                required={true}
                ignoreValidations={!configuracoes.frete.correiosAtivo}
              />
            </div>
          </div>
        </div>
      </ContainerConfigCorreios>
    </>
  );
};
